import { combineReducers } from 'redux-immutable'
import option from './optionReducer'
import form from './formReducer'
import reserveHistory from './reserveHistoryReducer'
import result from './resultReducer'

const rootReducer = combineReducers({
    option,
    form,
    result,
    reserveHistory
})

export default rootReducer
